import {
  Button,
  Checkbox,
  Col,
  Form,
  InputNumber,
  Modal,
  Popover,
  Row,
  Space,
  Spin,
  Table,
  Typography,
} from "antd";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ListActionButton,
  ModalCustom,
} from "components/common";
import React, { useEffect, useRef, useState } from "react";
import Icons from "assets/icons";
import {
  catalogService,
  discountsService,
  medicalExaminationService,
  servicePackage,
  technicalService,
} from "api";
import "./ModalDetailVoucher.scss";
import { ReactComponent as RecycleIconSVG } from "assets/images/svg/recycle.svg";
import Notification from "components/common/notification/notification";
import { ExcelSVG } from "assets";
import Icon from "assets/icons";
import { ColumnProps } from "types/models";
//import FormAdd from "./FormAdd/FormAdd";
import { Select } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  formatToCurrencyType,
  formatDateToStringTimezone_7,
  formatDateToString,
} from "helper/common";
import { FIELD_TYPE, FORMAT_TIME, tabKeys } from "types/enums";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setIdKM, setKM } from "redux/reducer/employee";
import dayjs from "dayjs";
import { setActiveKey } from "redux/reducer/common";
import { RangePickerProps } from "antd/es/date-picker";
import { DataFormField } from "types/models/input-field-type";
const {
  INPUT,
  DATE,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  DATE_ON,
  NUMBER,
  CHECKBOX,
  RADIO,
  NORMAL_CHECKBOX,
  NORMAL_CHECKBOX_NONE,
  DATE_DISABLE_NO_DAY,
  COMBO_BOX,
  TEXT_AREA,
} = FIELD_TYPE;
const ModalDetailVoucher = ({ isShowModal, handleCancel, handleOk }) => {
  const employeesStore = useAppSelector((state) => state.employeesReducer.cckm);
  const [loading, setLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const cssProps = {
    labelCol: { xs: 8, sm: 8, md: 8, lg: 12, xl: 12 },
    wrapperCol: { xs: 16, sm: 16, md: 12, lg: 12, xl: 12 },
    css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
  };
  const cssProps2 = {
    labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
    wrapperCol: { xs: 16, sm: 16, md: 18, lg: 24, xl: 24 },
    css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
  };
  const dataTTAP: DataFormField[] = [
    {
      type: SELECT,
      name: "nguonBenhNhanList",
      mode: "multiple",
      label: "Chọn nguồn bệnh nhân",
      placeholder: "Tất cả",
      ...cssProps2,
      //  disable:true,
    },
    {
      type: COMBO_BOX,
      mode: "multiple",
      name: "loaiKCBList",
      label: "Chọn loại KCB",
      placeholder: "Tất cả",
      ...cssProps2,
      // disable:true,
      // options: loaiKCB
    },
    {
      type: COMBO_BOX,
      name: "doiTuongList",
      placeholder: "Tất cả",
      mode: "multiple",
      //  disable:true,
      label: "Chọn Đối tượng",
      ...cssProps2,
    },
    {
      type: DATE_DISABLE_NO_DAY,
      disableDate: false,
      //needConfirm:false,
      rules: [{ required: true, message: "Áp dụng từ là bắt buộc!" }],
      optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
      label: "Áp dụng từ",
      name: "ngayBatDau",
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 16, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
      // disabledDate: false,
      // disable:true,
    },
    {
      type: DATE_DISABLE_NO_DAY,
      disableDate: false,
      // needConfirm:false,
      // disable:true,
      rules: [{ required: true, message: "Áp dụng từ là bắt buộc!" }],
      optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
      label: "Áp dụng đến",
      name: "ngayKetThuc",
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 16, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 24, lg: 12, xl: 12 },
      // disabledDate: false,
    },
  ];
  const dataTTC = [
    {
      type: INPUT,
      name: "tenChuongTrinh",
      label: "Tên chương trình",
      //  disable:true,
      ...cssProps,
      rules: [
        { required: true, message: "Tên chương trình là bắt buộc!" },
        {
          max: 200,
          message: "Định dạng mã chương trình không đúng",
        },
      ],
    },
    {
      type: INPUT,
      name: "maChuongTrinh",
      label: "Mã chương trình",
      //  disable:true,
      ...cssProps,
      rules: [
        { required: true, message: "Đầu mã là bắt buộc!" },
        {
          max: 10,
          message: "Định dạng mã thẻ không đúng",
        },
      ],
    },
    {
      type: NUMBER,
      name: "soLanApDung",
      label: "Số lượng áp dụng",
      disable: false,
      ...cssProps,
      rules: [
        { required: true, message: "Số lượng áp dụng là bắt buộc!" },
        // {
        //   pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        //   message: "Chỉ cho phép nhập số",
        // },
        // {
        //   max: 10,
        //   min:0,
        //   message: "Số lượng không vượt quá 10 số",
        // },
      ],
    },
    {
      name: "isKhongGioiHan",
      type: NORMAL_CHECKBOX_NONE,
      label: "Không giới hạn",
      valuePropName: "checked",
      //  disable:true,
      ...cssProps,
      // checkbox: [
      //   {
      //     label: "Không giới hạn",
      //     value: 1,
      //     span: 32,
      //   },
      // ],
    },
    {
      type: INPUT,
      name: "soLuotApDungConLai",
      label: "Số lượng áp dụng còn lại",
      ...cssProps,
      disable: true,
    },
    {
      type: TEXT_AREA,
      name: "moTa",
      label: "Mô tả",
      // disable:true,
      rules: [
        // {
        //   pattern: /^[0-9]*$/, // Quy tắc để chỉ cho phép nhập số
        //   message: "Chỉ cho phép nhập số",
        // },
        {
          max: 500,
          message: "Mô tả không vượt quá 500 chữ",
        },
      ],
      allowClear: true,
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 24, lg: 24, xl: 24 },
      style: { height: "180px" },
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
    },
  ];
  const dataPTKM = [
    {
      type: SELECT,
      name: "type",
      options: [
        { value: 1, label: "Chiết khấu theo giá trị thanh toán" },
        { value: 2, label: "Chiết khấu theo dịch vụ" },
        { value: 3, label: "Ưu đãi dịch vụ theo tổng giá trị thanh toán" },
      ],
      labelCol: { xs: 8, sm: 8, md: 8, lg: 24, xl: 24 },
      wrapperCol: { xs: 16, sm: 16, md: 24, lg: 24, xl: 24 },
      css: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 },
      onChange: (value: any) => {
        setSelectedOption(value);
      },
    },
  ];
  const dispatch = useAppDispatch();
  let id = useAppSelector((state) => state.employeesReducer.idKM);
  const [dataSourceService, setDataSourceService] = useState([]);
  const [dataSourceThird, setDataSourceThird] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [selectedOption, setSelectedOption] = useState(1);
  const [optionsData, setOptionData] = useState(dataPTKM);
  const [fieldsTTC, setFieldsTTC] = useState(dataTTC);
  const [fieldsTTAP, setFieldsTTAP] = useState(dataTTAP);
  useEffect(() => {
    getListNguonBN();
    fetchObjects();
    ColumnsService();
    getListGoiDichVu();
    getListLoaiKCB();
    getDetailsKM(id);
  }, [id]);
  useEffect(() => {
    form.setFieldsValue({
      ...employeesStore,
      isKhongGioiHan: employeesStore?.isKhongGioiHan ? true : false,
      createdDate: employeesStore?.createdDate
        ? dayjs(employeesStore?.createdDate)
        : null,
      ngayBatDau: employeesStore?.ngayBatDau
        ? dayjs(employeesStore?.ngayBatDau)
        : null,
      ngayKetThuc: employeesStore?.ngayKetThuc
        ? dayjs(employeesStore?.ngayKetThuc)
        : null,
    });
  }, [employeesStore, employeesStore?.isKhongGioiHan]);
  useEffect(() => {
    if (employeesStore?.isKhongGioiHan === true) {
      const updatedFieldsCV = fieldsTTC.map((field) => {
        if (
          field.name === "soLanApDung" ||
          field.name === "soLuotApDungConLai"
        ) {
          return {
            ...field,
            disable: true,
          };
        } else {
          return {
            ...field,
            disable: false,
          };
        }
      });
      setFieldsTTC(updatedFieldsCV);
    } else {
      const updatedFieldsCV = fieldsTTC.map((field) => {
        if (field.name === "soLuotApDungConLai") {
          return {
            ...field,
            disable: true,
          };
        } else {
          return {
            ...field,
            disable: false,
          };
        }
      });
      setFieldsTTC(updatedFieldsCV);
    }
  }, [id, employeesStore?.isKhongGioiHan]);
  const getDetailsKM = async (id) => {
    if (id !== undefined || id !== null) {
      setLoading(true);
      try {
        let keyCounter = 1;
        const res = await discountsService.detailKM(id);
        dispatch(setKM(res));
        setDataSourceService(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setSelectedOption(res?.type);
        setDataSourceThird(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setDataSource(
          res?.dichVuUuDais.map((item) => {
            return {
              ...item,
              key: keyCounter++,
            };
          })
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        // setLoading(false);
        // Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
      }
    }
  };
  const getListLoaiKCB = async () => {
    try {
      const res = await catalogService.getListLoaiKCB();
      fieldsTTAP.find((e) => e.name == "loaiKCBList").options = await res.map(
        (e) => {
          return { value: e.id, label: e.tenLoaiKCB };
        }
      );
      setFieldsTTAP([...fieldsTTAP]);
    } catch (error) {
      // Notification("error", "Đã có lỗi khi lấy danh sách loại khám chữa bệnh");
      // fields[8].options = [];
    }
  };
  const getListNguonBN = async () => {
    try {
      const response = await medicalExaminationService.getSourcePatient();
      //console.log("Nguồn", response.data);
      fieldsTTAP.find((e) => e.name == "nguonBenhNhanList").options =
        response.data.map((e) => {
          return { value: e.id, label: e.tenNguonBenhNhan };
        });
      setFieldsTTAP([...fieldsTTAP]);
    } catch (error) {
      Notification(
        "error",
        "Lỗi xảy ra khi lấy thông tin danh mục nguồn bênh nhân"
      );
    }
  };
  const fetchObjects = async () => {
    try {
      const response = await medicalExaminationService.getListObjects();
      //  console.log(response.data);

      fieldsTTAP.find((e) => e.name == "doiTuongList").options =
        response.data.map((e) => {
          return { value: e.id, label: e.tenDoiTuong };
        });
      setFieldsTTAP([...fieldsTTAP]);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const columnsValue = [
    {
      title: "Tổng giá trị",
      dataIndex: "dieuKien",
      rules: [{ max: 10, message: "Không được nhập quá 10 số" }],
      render: (text, record) => (
        <InputNumber
          value={text}
          // onChange={(value) => handleInputChange(record.key, "dieuKien", value)}
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
          // disabled
        />
      ),
    },
    {
      title: "Chiết khấu",
      dataIndex: "giamGia",
      render: (text, record) => (
        <Row gutter={8}>
          <Col flex="auto">
            <InputNumber
              value={record.loaiGiamGia === 0 ? text : text}
              // onChange={(value) =>
              //   handleInputChange(record.key, "giamGia", value)
              // }
              style={{ width: "100%" }}
              formatter={
                record.loaiGiamGia === 0 ? formatToCurrencyType : undefined
              }
              parser={
                record.loaiGiamGia === 0
                  ? (value) => value.replace(/\D/g, "")
                  : undefined
              }
              // disabled
            />
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 1 ? "primary" : "default"}
              //  onClick={() => handleDiscountTypeChange(record.key, 1)}
              className="buttonphantram"
            >
              %
            </Button>
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 0 ? "primary" : "default"}
              // onClick={() => handleDiscountTypeChange(record.key, 0)}
              className="buttonphantram"
            >
              đ
            </Button>
          </Col>
        </Row>
      ),
    },
    {
      title: "Mức giảm tối đa",
      dataIndex: "giamGiaToiDa",
      render: (text, record) => (
        <InputNumber
          value={text}
          // onChange={(value) =>
          //   handleInputChange(record.key, "giamGiaToiDa", value)
          // }
          // disabled
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
          //  disabled={record.loaiGiamGia === 0}
        />
      ),
    },
  ];
  const columnsThird = [
    {
      title: "Tổng giá trị",
      dataIndex: "dieuKien",
      render: (text, record) => (
        <InputNumber
          value={text}
          // onChange={(value) => handleInputChange(record.key, "dieuKien", value)}
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
          //  disabled
        />
      ),
    },
    {
      title: "Gói dịch vụ ưu đãi",
      dataIndex: "goiDichVuList",
      render: (text, record) => (
        <Select
          mode="multiple"
          value={text}
          // onChange={(value) =>
          //   handleInputChange(record.key, "goiDichVuList", value)
          // }
          style={{ width: "100%" }}
          placeholder="Tìm kiếm gói dịch vụ"
          options={goiDichVu}
          showSearch
          //  disabled
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Dịch vụ ưu đãi",
      dataIndex: "dichVuList",
      render: (text, record) => (
        <Select
          mode="multiple"
          value={text}
          // onChange={(value) =>
          //   handleInputChange(record.key, "dichVuList", value)
          // }
          style={{ width: "100%" }}
          placeholder="Tìm kiếm theo tên dịch vụ"
          options={serviceOptions}
          showSearch
          //  disabled
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Số lượng tối đa",
      dataIndex: "soLanApDung",
      render: (text, record) => (
        <InputNumber
          value={text}
          // onChange={(value) =>
          //   handleInputChange(record.key, "soLanApDung", value)
          // }
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
          //  disabled
        />
      ),
    },
  ];
  const [serviceOptions, setServiceOptions] = useState([]);
  const [goiDichVu, setGoiDichVu] = useState([]);
  const getListGoiDichVu = async () => {
    try {
      const paramss = { page: 1, limit: 1000 };
      const response = await servicePackage.getListServicePackage(paramss);
      // console.log(response);
      const optionss = response.data.map((e) => {
        return { value: e.id, label: e.tenGoiDichVu };
      });
      setGoiDichVu(optionss);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục gói dịch vụ");
    }
  };
  const ColumnsService = async () => {
    try {
      const paramss = { page: 1, limit: 1000 };
      const response = await technicalService.searchListTechnicalService(
        paramss
      );
      const options = response.map((e) => {
        return { value: e.id, label: e.tenDichVu };
      });
      setServiceOptions(options);
    } catch (err) {
      Notification("error", "Lỗi xảy ra khi lấy danh mục đối tượng");
    }
  };
  const columnsService = [
    {
      title: "Dịch vụ",
      dataIndex: "dichVuList",
      render: (text, record) => (
        <Select
          value={text}
          // onChange={(value) =>
          //   handleInputChange(record.key, "dichVuList", value)
          // }
          style={{ width: "100%" }}
          mode="multiple"
          options={serviceOptions}
          showSearch
          //  disabled
          filterOption={(input, option) =>
            (option?.label?.toString().toLowerCase() ?? "").includes(
              input.toLowerCase()
            )
          }
        ></Select>
      ),
      width: "30%",
    },
    {
      title: "Chiết khấu",
      dataIndex: "giamGia",
      render: (text, record) => (
        <Row gutter={8}>
          <Col flex="auto">
            <InputNumber
              value={record.loaiGiamGia === 0 ? text : text}
              // onChange={(value) =>
              //   handleInputChange(record.key, "giamGia", value)
              // }
              style={{ width: "100%" }}
              formatter={
                record.loaiGiamGia === 0 ? formatToCurrencyType : undefined
              }
              parser={
                record.loaiGiamGia === 0
                  ? (value) => value.replace(/\D/g, "")
                  : undefined
              }
              //   disabled
            />
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 1 ? "primary" : "default"}
              // onClick={() => handleDiscountTypeChange(record.key, 1)}
              className="buttonphantram"
            >
              %
            </Button>
          </Col>
          <Col>
            <Button
              type={record.loaiGiamGia === 0 ? "primary" : "default"}
              //  onClick={() => handleDiscountTypeChange(record.key, 0)}
              className="buttonphantram"
            >
              đ
            </Button>
          </Col>
        </Row>
      ),
    },
    {
      title: "Mức giảm tối đa",
      dataIndex: "giamGiaToiDa",
      render: (text, record) => (
        <InputNumber
          value={text}
          // onChange={(value) =>
          //   handleInputChange(record.key, "giamGiaToiDa", value)
          // }
          style={{ width: "100%" }}
          formatter={formatToCurrencyType}
          parser={(value) => value.replace(/\D/g, "")}
          //  disabled={record.loaiGiamGia === 0}
          // disabled
        />
      ),
    },
  ];
  return (
    <Spin spinning={loading}>
      <Modal
        title="Xem chi tiết thông tin ưu đãi"
        centered
        open={isShowModal}
        onCancel={handleCancel}
        width={1152}
        className="modal-add-prepay"
        footer=""
      >
        <Form form={form}>
          <div className="discountsAdd">
            <div style={{ width: "100%", display: "flex" }}>
              <div
                className="container"
                style={{ width: "69%", marginRight: "1%" }}
              >
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Row style={{ marginTop: "4px" }} justify={"start"}>
                    <Typography.Text strong>Thông tin chung</Typography.Text>
                  </Row>
                  <Row justify={"space-between"}>
                    <Col>
                      <Row gutter={[16, 8]}>
                        <InputFields data={fieldsTTC}></InputFields>
                      </Row>
                    </Col>
                  </Row>
                </Space>
              </div>
              <div className="container" style={{ width: "30%" }}>
                <Space direction="vertical" style={{ width: "100%" }}>
                  <Row style={{ marginTop: "4px" }} justify={"start"}>
                    <Typography.Text strong>Thông tin áp dụng</Typography.Text>
                  </Row>
                  <Row justify={"space-between"}>
                    <Col>
                      <Row gutter={[12, 8]}>
                        <InputFields data={fieldsTTAP}></InputFields>
                      </Row>
                    </Col>
                  </Row>
                </Space>
              </div>
            </div>
            <div className="container">
              <Space direction="vertical" style={{ width: "100%" }}>
                <Row justify="space-between">
                  <Col>
                    <Row style={{ marginTop: "4px" }} justify="start">
                      <Typography.Text strong>
                        Phương thức khuyến mãi
                      </Typography.Text>
                    </Row>
                  </Col>
                </Row>
                <Row justify="center">
                  <InputFields data={optionsData} />
                </Row>
                {selectedOption === 1 && (
                  <Row justify="center">
                    <Table
                      bordered
                      dataSource={dataSource}
                      columns={columnsValue}
                      pagination={false}
                    />
                  </Row>
                )}
                {selectedOption === 2 && (
                  <Row justify="center">
                    <Table
                      bordered
                      dataSource={dataSourceService}
                      columns={columnsService}
                      pagination={false}
                    />
                  </Row>
                )}
                {selectedOption === 3 && (
                  <Row justify="center">
                    <Table
                      bordered
                      dataSource={dataSourceThird}
                      columns={columnsThird}
                      pagination={false}
                    />
                  </Row>
                )}
              </Space>
            </div>
          </div>
        </Form>
      </Modal>
    </Spin>
  );
};

export default ModalDetailVoucher;
